/************
 * Developed by : Shiva Software Solutions
 * Date : 11-05-2023
 * Descriptions : Reports page api calling
 ************/
import React from 'react';
import Api from '../../@crema/services/ApiConfig';
import IntlMessages from '../../@crema/utility/IntlMessages';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, onWriteCloudWatchLog} from './Common';
// const variables
import {
  sendReview,
  backReview,
  userRoleMaster,
} from '../../shared/constants/AppConst';
import {DataBrew} from 'aws-sdk';
import {
  FETCH_START,
  FETCH_ERROR,
  OPDDIGITIZATION_COUNT,
  OPDDIGITIZATION_MEDICINE,
  DIGITIZATION_DISEASE,
  INVESTIGATION_LAB,
  INVESTIGATION_RADIO,
  FETCH_SUCCESS,
  MEDICINE_CATEGORY_COUNT,
  DOCTOR_SPECIALIZATION_COUNT,
  INVESTIGATION_MRI_XRay,
  INVESTIGATION_BLOOD_TEST,
  INVESTIGATION_CATEGORY,
  INVESTIGATION_CATEGORY_DATA,
  PRESCRIPTION_COUNT,
  PRESCRIPTION_LOADER,
  ANTIBIOTIC_LOADER,
  DISEASE_LOADER,
  LAB_LOADER,
  RADIOLOGY_LOADER,
  MRI_XRAY_LOADER,
  SPECIALIZATION_LOADER,
  INVESCATEGORY_LOADER,
  BLOODTEST_LOADER,
  GET_ERX_FORMS_PDF,
  CHART_ERX_RESULT,
  CHART_ERX_TOTAL_RECORD,
  CHART_ERX_DETAILS_LOADER,
  SURGERY_LOADER,
  CHART_SURGERY_DATA,
} from '../../shared/constants/ActionTypes';
//AWS cloud watch name
var streamname = 'Redux_Actions';
var filename = 'reports.js';

export const mastereRx = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/reportDtls/ongetclientlistjwt', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/ongetclientlist', value)
              .then((data) => {})
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'ongetclientlist',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'ongetclientlist',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'ongetclientlist',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'ongetclientlist', '0', err),
      );
    }
  };
};

export const OPDDigitization_chart = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/reportDtls/OPDDigitization_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/OPDDigitization_chart', value)
              .then((data) => {
                dispatch({type: FETCH_SUCCESS}); 
                dispatch({
                  type: OPDDIGITIZATION_COUNT,
                  payload:
                    data.data.body.reportData?.length > 0
                      ? data.data.body.reportData[0]
                      : {},
                });
                // //medicine chart
                // dispatch({
                //   type: OPDDIGITIZATION_MEDICINE,
                //   payload: data.data.body.medicineReport,
                // });
                // //disease chart
                // dispatch({
                //   type: DIGITIZATION_DISEASE,
                //   payload: data.data.body.diseaseReport,
                // });
                // //investigation lab
                // dispatch({
                //   type: INVESTIGATION_LAB,
                //   payload: data.data.body.labInvesReport,
                // });
                // //investigation Radiology
                // dispatch({
                //   type: INVESTIGATION_RADIO,
                //   payload: data.data.body.radioInvesReport,
                // });

                // //doctor specialization
                // dispatch({
                //   type: DOCTOR_SPECIALIZATION_COUNT,
                //   payload: data.data.body.doctorSpecialization,
                // });
                // //medcategory based
                // // dispatch({
                // //   type: MEDICINE_CATEGORY_COUNT,
                // //   payload: data.data.body.medCategoryReport,
                // // });

                // //MRI / X-Ray based
                // dispatch({
                //   type: INVESTIGATION_MRI_XRay,
                //   payload: data.data.body.mri_xRayReport,
                // });

                // dispatch({
                //   type: INVESTIGATION_BLOOD_TEST,
                //   payload: data.data.body.bloodTestReport,
                // });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'OPDDigitization_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'OPDDigitization_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'OPDDigitization_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'OPDDigitization_chart',
          '0',
          err,
        ),
      );
    }
  };
};

export const investigationCategory_chart = (value) => {
  return (dispatch) => {
    dispatch({type: INVESCATEGORY_LOADER,
      payload:true
    });
    try {
      jwtAxios
        .post('v1/reportDtls/investigationCategory_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/investigationCategory_chart', value)
              .then((data) => {
                dispatch({type: INVESCATEGORY_LOADER,payload:false});

                //investigation category based
                dispatch({
                  type: INVESTIGATION_CATEGORY_DATA,
                  payload: data.data.body.categoryMaster,
                });
                dispatch({
                  type: INVESTIGATION_CATEGORY,
                  payload: data.data.body.invesCategoryReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'investigationCategory_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'investigationCategory_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'investigationCategory_chartjwt',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'investigationCategory_chart',
          '0',
          err,
        ),
      );
    }
  };
};

//anitbiotic chart
export const Antibiotic_chart = (value) => {
  return (dispatch) => {
    dispatch({type: ANTIBIOTIC_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Antibiotic_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Antibiotic_chart', value)
              .then((data) => {
                dispatch({type: ANTIBIOTIC_LOADER,payload:false});
                //medicine chart
                dispatch({
                  type: OPDDIGITIZATION_MEDICINE,
                  payload: data.data.body.medicineReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Antibiotic_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Antibiotic_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Antibiotic_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'Antibiotic_chart',
          '0',
          err,
        ),
      );
    }
  };
};

//disease chart
export const Disease_chart = (value) => {
  return (dispatch) => {
    dispatch({type: DISEASE_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Disease_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Disease_chart', value)
              .then((data) => {
                dispatch({type: DISEASE_LOADER,payload:false});
                //disease chart
                dispatch({
                  type: DIGITIZATION_DISEASE,
                  payload: data.data.body.diseaseReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Disease_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Disease_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Disease_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'Disease_chart', '0', err),
      );
    }
  };
};

//lab chart

export const Lab_chart = (value) => {
  return (dispatch) => {
    dispatch({type: LAB_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Lab_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Lab_chart', value)
              .then((data) => {
                dispatch({type: LAB_LOADER,payload:false});
                //investigation lab
                dispatch({
                  type: INVESTIGATION_LAB,
                  payload: data.data.body.labInvesReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Lab_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Lab_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Lab_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'Lab_chart', '0', err),
      );
    }
  };
};

//radioloy chart
export const Radiology_chart = (value) => {
  return (dispatch) => {
    dispatch({type: RADIOLOGY_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Radiology_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Radiology_chart', value)
              .then((data) => {
                dispatch({type: RADIOLOGY_LOADER,payload:false});
                //investigation Radiology
                dispatch({
                  type: INVESTIGATION_RADIO,
                  payload: data.data.body.radioInvesReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Radiology_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Radiology_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Radiology_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'Radiology_chart', '0', err),
      );
    }
  };
};

//specialization chart

export const Specialization_chart = (value) => {
  return (dispatch) => {
    dispatch({type: SPECIALIZATION_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Specialization_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Specialization_chart', value)
              .then((data) => {
                dispatch({type: SPECIALIZATION_LOADER,payload:false});
                //doctor specialization
                dispatch({
                  type: DOCTOR_SPECIALIZATION_COUNT,
                  payload: data.data.body.doctorSpecialization,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Specialization_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Specialization_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Specialization_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'Specialization_chart',
          '0',
          err,
        ),
      );
    }
  };
};

//blood test chart

export const Bloodtest_chart = (value) => {
  return (dispatch) => {
    dispatch({type: BLOODTEST_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Bloodtest_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Bloodtest_chart', value)
              .then((data) => {
                dispatch({type: BLOODTEST_LOADER,payload:false});

                dispatch({
                  type: INVESTIGATION_BLOOD_TEST,
                  payload: data.data.body.bloodTestReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Bloodtest_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Bloodtest_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Bloodtest_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'Bloodtest_chart', '0', err),
      );
    }
  };
};

//mrixray test chart

export const MRIXRAY_chart = (value) => {
  return (dispatch) => {
    dispatch({type: MRI_XRAY_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/MRIXRAY_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/MRIXRAY_chart', value)
              .then((data) => {
                dispatch({type: MRI_XRAY_LOADER,payload:false});
                //MRI / X-Ray based
                dispatch({
                  type: INVESTIGATION_MRI_XRay,
                  payload: data.data.body.mri_xRayReport,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'MRIXRAY_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'MRIXRAY_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'MRIXRAY_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'MRIXRAY_chart', '0', err),
      );
    }
  };
};

//prescription count
export const Prescription_chart = (value) => {
  return (dispatch) => {
    dispatch({type: PRESCRIPTION_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/Prescription_chartJWT', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/Prescription_chart', value)
              .then((data) => {
                dispatch({type:PRESCRIPTION_LOADER,
                  payload:false
                })
                dispatch({
                  type: PRESCRIPTION_COUNT,
                  payload:
                    data.data.body.prescriptioncount?.length > 0
                      ? data.data.body.prescriptioncount[0]
                      : {},
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Prescription_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Prescription_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Prescription_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'Prescription_chart',
          '0',
          err,
        ),
      );
    }
  };
};


export const onGetErxFormsPDF = ({erxId, userCode, clientId},pagefrom=0) => {
  return (dispatch) => {
    if(pagefrom==0){
          dispatch({type: FETCH_START});
    }
    else{
           dispatch({type: GET_ERX_FORMS_PDF,payload:  [],});
           dispatch({type: CHART_ERX_DETAILS_LOADER, payload: true})
    }
    let body = {erxId, userCode, clientId};

    //Call Update Token  - Get Token
    try {
      jwtAxios.post('v1/reportDtls/getErxFormsPDFjwt', body).then((data) => {
        if (data.status === 200) {
          try {
            const jwtToken = data.data.body['token'];
            let bodytoken = {erxId, jwtToken, userCode, clientId};
            jwtAxios
              .post('v1/reportDtls/getErxFormsPDF', bodytoken)
              .then((data) => {
                if (data.data.body) {
                  if(pagefrom==0){
                        dispatch({type: FETCH_SUCCESS});
                  }
                  else{
                    dispatch({type: CHART_ERX_DETAILS_LOADER, payload: false})
                  }
                  
                  dispatch({
                    type: GET_ERX_FORMS_PDF,
                    payload: data.data.body?.formPdfUrl || []
                  }); 
                }
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'onGetErxFormsPDF',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'onGetErxFormsPDF',
                '0',
                err,
              ),
            );
          }
        }
      });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetErxFormsPDF',
          '0',
          err,
        ),
      );
    }
  };
};

//get eRx result 
export const getCharteRxResult = (value) => {
  return (dispatch) => {
    dispatch({type: ANTIBIOTIC_LOADER, payload: true});
    // dispatch({type: CHART_ERX_RESULT,payload:[]});
    // dispatch({type: CHART_ERX_TOTAL_RECORD,payload:0});

    try {
      //  dispatch({type: FETCH_START});
      dispatch({type: CHART_ERX_DETAILS_LOADER, payload: true})
      jwtAxios
        .post('v1/reportDtls/getcharteRxDetailsJWT', value)
        .then((data) => {
          try {
            jwtAxios
              .post('v1/reportDtls/getcharteRxDetails', {'jwtToken':data.data.body['token']})
              .then((data) => {
                dispatch({type: ANTIBIOTIC_LOADER, payload: false});

                dispatch({
                  type: CHART_ERX_RESULT,
                  payload: data.data.body.erxList,
                });
                dispatch({
                  type: CHART_ERX_TOTAL_RECORD,
                  payload: data.data.body.totalRecord,
                });
                dispatch({type: FETCH_SUCCESS});
                dispatch({type: CHART_ERX_DETAILS_LOADER, payload: false})
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch({type: CHART_ERX_DETAILS_LOADER, payload: false})
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'getCharteRxResult',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'getCharteRxResult',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch({type: CHART_ERX_DETAILS_LOADER, payload: false})
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'getCharteRxResult',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'getCharteRxResult',
          '0',
          err,
        ),
      );
    }
  };
};

//Surgery chart
export const Surgery_chart = (value) => {
  return (dispatch) => {
    dispatch({type: SURGERY_LOADER,payload:true});
    try {
      jwtAxios
        .post('v1/reportDtls/procedure_chartJWT', value)
        .then((data) => {
          try {
            const jwtvalue = {jwtToken : data?.data?.body?.token};
            jwtAxios
              .post('v1/reportDtls/procedure_chart', jwtvalue)
              .then((data) => {
                dispatch({type: SURGERY_LOADER, payload:false});
                dispatch({
                  type: CHART_SURGERY_DATA,
                  payload: data?.data?.body?.procedure,
                });
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'Surgery_chart',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'Surgery_chartJWT',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'Surgery_chartJWT',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'Surgery_chart', '0', err),
      );
    }
  };
};